<script lang="ts">
	import Subfooter from '$lib/components/common/Subfooter.svelte'
	import Logo from '$lib/components/partials/Logo.svelte'
	import { page } from '$app/stores'
	import { t } from 'svelte-i18n-lingui'
	import { getContextScope } from '$lib/js/helpers/i18n'

	let footer = $page.data.footer
	const scope = getContextScope()
</script>

<footer class="footer">
	<!-- Don't display footer in account pages -->
	{#if !$page.url.pathname.includes('customer/account') && !$page.url.pathname.includes('customer/address') && !$page.url.pathname.includes('sales/order') && !$page.url.pathname.includes('stripe/customer')}
		<Subfooter />
	{/if}
	<div class="container-bg">
		<div class="container footer__inner">
			<div class="footer__columns">
				<div class="footer__col">
					<a href="/{scope}" class="footer-logo" aria-label={$t`Home`}>
						<Logo />
					</a>

					<div class="footer__icons">
						<a href="https://www.instagram.com/bixoto_com" aria-label="Instagram">
							<span class="icon icon-instagram" />
						</a>
						<a href="https://www.facebook.com/bixoto" aria-label="Facebook">
							<span class="icon icon-facebook" />
						</a>
						<a href="https://twitter.com/bixoto_com" aria-label="Twitter">
							<span class="icon icon-twitter" />
						</a>
						<a href="https://www.linkedin.com/company/bixoto" aria-label="LinkedIn">
							<span class="icon icon-linkedin" />
						</a>
						<a href="https://www.pinterest.es/bixoto_com/" aria-label="Pinterest">
							<span class="icon icon-pinterest" />
						</a>
					</div>

					<ul>
						<li class="nav item">
							<img
								src="/images/enisa.png"
								alt="Enisa"
								class="enisa"
								height="103"
								width="126"
								loading="lazy"
							/>
						</li>
					</ul>
				</div>

				{#each footer.column as col}
					<div class="footer__col {col.title}">
						<h2 class="head-5">{col.title}</h2>

						<ul class="footer links">
							{#each col.list as list}
								<li class="nav item">
									{#if list.link.indexOf('https') === -1}
										<a href="/{scope}{list.link}">{list.item}</a>
									{:else}
										<a href={list.link}>{list.item}</a>
									{/if}
								</li>
							{/each}
						</ul>
					</div>
				{/each}
			</div>

			<div class="footer__text">
				<p>
					{@html $t`We are Bixoto, a startup from Barcelona and the first fully European, <strong>close and sustainable</strong> e-commerce. We work to put at your disposal a wide catalog of quality products at the best prices.`}
				</p>
				<p>
					{@html $t`At Bixoto we offer you <strong>more than 500,000 products of all kinds</strong> online and an unbeatable shopping experience.`}
				</p>
			</div>
		</div>

		<div class="container copyright">
			<div class="images">
				<img src="/images/europe.png" alt="Bandera Europa" width="40" height="40" loading="lazy" />
				<img src="/images/spain.png" alt="Bandera España" width="40" height="40" loading="lazy" />
			</div>
			<small
				>Copyright {new Date().getFullYear()} - BIXOTO IBERIA SL - {$t`All rights reserved`}</small
			>
		</div>
	</div>
</footer>

<style lang="scss">
	.container-bg {
		max-width: 1340px;
		margin: 0 auto;
		width: 100%;

		@media (min-width: 769px) {
			padding: 0 20px;
			width: calc(100% - 40px);
		}

		@media (min-width: 1025px) {
			padding: 0 50px;
			width: calc(100% - 100px);
		}
	}

	.footer {
		&__inner {
			background: #ffede6;
			margin-top: 30px;
			margin-bottom: 30px;
			padding-top: 30px;
			padding-bottom: 30px;

			@media (min-width: 1025px) {
				margin-top: 80px;
				padding-top: 50px;
				padding-bottom: 50px;
			}
		}

		&__columns {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			column-gap: 15px;
		}

		&__col {
			margin-bottom: 35px;
			width: 100%;

			@media (min-width: 580px) {
				width: calc(50% - 15px);
			}

			@media (min-width: 950px) {
				width: calc(25% - 15px);
			}

			h2 {
				margin-top: 0;
				color: black;
				font-weight: 900;
				margin-bottom: 12px;

				@media (max-width: 768px) {
					font-size: 18px;
				}
			}

			ul {
				padding: 0;

				li.nav.item {
					margin: 0;
					padding: 0;
					border: 0;

					a {
						display: block;
						color: black;
						padding: 3px 0;

						/* [BF] make these slightly larger on mobile */
						@media (max-width: 950px) {
							padding: 5px 0;
						}

						&:hover {
							color: var(--main);
						}
					}
				}
			}

			&.Tiendas {
				ul {
					display: flex;
					flex-wrap: wrap;
					column-gap: 20px;

					li.nav.item {
						//
					}
				}
			}

			.enisa {
				height: 100%;
				width: 130px;
			}
		}

		&__icons {
			margin: 5px -5px 15px;

			a {
				display: inline-block;
				margin: 5px 8px;
				color: black;

				&:hover {
					span.icon {
						@media (min-width: 769px) {
							color: var(--main);
						}
					}
				}

				span.icon {
					font-size: 22px;
					transition: all linear 0.125s;
				}
			}
		}

		&__text {
			padding-top: 30px;

			@media (min-width: 769px) {
				display: flex;
				justify-content: space-between;
			}

			p {
				@media (min-width: 769px) {
					width: calc(50% - 20px);
				}

				strong {
					display: inline;
					padding: 0;
					font-weight: 700;
					color: #fff;
				}
			}
		}
	}

	.copyright {
		background: #efefef;
		padding-top: 10px;
		padding-bottom: 10px;
		display: flex;
		align-items: center;
		text-align: left;

		.images {
			display: flex;
			column-gap: 8px;
			margin-right: 20px;
		}

		@media (min-width: 769px) {
			padding-top: 15px;
			padding-bottom: 15px;
			margin-bottom: 30px;
		}
	}
</style>
